// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProjectItemCommitmentTabQueryVariables = Types.Exact<{
  projectItemId: Types.Scalars['ID']['input'];
}>;


export type ProjectItemCommitmentTabQuery = { __typename?: 'Query', projectItem: { __typename?: 'ProjectItem', id: string, commitmentLineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, quantity?: number | null | undefined, committedInCents: number, owner:
        | { __typename?: 'Commitment', id: string, displayName: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } }
        | { __typename?: 'CommitmentChangeOrder', id: string, displayName: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } }
       }> } };

export type ProjectItemCommitmentLineItemFragment = { __typename?: 'CommitmentLineItem', id: string, quantity?: number | null | undefined, committedInCents: number, owner:
    | { __typename?: 'Commitment', id: string, displayName: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } }
    | { __typename?: 'CommitmentChangeOrder', id: string, displayName: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } }
   };

export const ProjectItemCommitmentLineItemFragmentDoc = gql`
    fragment ProjectItemCommitmentLineItem on CommitmentLineItem {
  id
  quantity
  committedInCents
  owner {
    id
    displayName
    accountingNumber
    blueprintUrl {
      path
    }
  }
}
    `;
export const ProjectItemCommitmentTabDocument = gql`
    query ProjectItemCommitmentTab($projectItemId: ID!) {
  projectItem(id: $projectItemId) {
    id
    commitmentLineItems {
      ...ProjectItemCommitmentLineItem
    }
  }
}
    ${ProjectItemCommitmentLineItemFragmentDoc}`;

/**
 * __useProjectItemCommitmentTabQuery__
 *
 * To run a query within a React component, call `useProjectItemCommitmentTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectItemCommitmentTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectItemCommitmentTabQuery({
 *   variables: {
 *      projectItemId: // value for 'projectItemId'
 *   },
 * });
 */
export function useProjectItemCommitmentTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectItemCommitmentTabQuery, ProjectItemCommitmentTabQueryVariables> & ({ variables: ProjectItemCommitmentTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectItemCommitmentTabQuery, ProjectItemCommitmentTabQueryVariables>(ProjectItemCommitmentTabDocument, options);
      }
export function useProjectItemCommitmentTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectItemCommitmentTabQuery, ProjectItemCommitmentTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectItemCommitmentTabQuery, ProjectItemCommitmentTabQueryVariables>(ProjectItemCommitmentTabDocument, options);
        }
// @ts-ignore
export function useProjectItemCommitmentTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectItemCommitmentTabQuery, ProjectItemCommitmentTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectItemCommitmentTabQuery, ProjectItemCommitmentTabQueryVariables>;
export function useProjectItemCommitmentTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectItemCommitmentTabQuery, ProjectItemCommitmentTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectItemCommitmentTabQuery | undefined, ProjectItemCommitmentTabQueryVariables>;
export function useProjectItemCommitmentTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectItemCommitmentTabQuery, ProjectItemCommitmentTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectItemCommitmentTabQuery, ProjectItemCommitmentTabQueryVariables>(ProjectItemCommitmentTabDocument, options);
        }
export type ProjectItemCommitmentTabQueryHookResult = ReturnType<typeof useProjectItemCommitmentTabQuery>;
export type ProjectItemCommitmentTabLazyQueryHookResult = ReturnType<typeof useProjectItemCommitmentTabLazyQuery>;
export type ProjectItemCommitmentTabSuspenseQueryHookResult = ReturnType<typeof useProjectItemCommitmentTabSuspenseQuery>;
export type ProjectItemCommitmentTabQueryResult = Apollo.QueryResult<ProjectItemCommitmentTabQuery, ProjectItemCommitmentTabQueryVariables>;